export type RoleCodeJapanese = '全権管理者' | 'イネーブラー' | 'ユーザー'
export type RoleCode = 'SUPER_ADMIN' | 'ENABLER' | 'USER'
export const roleMapping: Record<RoleCodeJapanese, RoleCode> = {
  全権管理者: 'SUPER_ADMIN',
  イネーブラー: 'ENABLER',
  ユーザー: 'USER',
}

// roleMapping の逆引き。ユーザーエクスポート時に User.roles[].code を、
// ユーザー一括登録 CSV が受け付ける日本語ロール名へ変換するために使う。
export const roleCodeToJapanese: Record<RoleCode, RoleCodeJapanese> = {
  SUPER_ADMIN: '全権管理者',
  ENABLER: 'イネーブラー',
  USER: 'ユーザー',
}
